const INNER_PIE_LABEL_RATIO = 1.05;
const PIE_LABEL_RATIO = 1.17;
export const DEG_TO_RAD_CONVERTER = Math.PI / 180;
export const startAngle = 90;
export const endAngle = startAngle - 360;

export const isLabelHidden = (percent, threshold) => percent * 100 < threshold;

export const getPieLabelPosition = ({
  cx,
  cy,
  midAngle,
  outerRadius,
}) => {
  const radiusInner = outerRadius * INNER_PIE_LABEL_RATIO;
  const radius = outerRadius * PIE_LABEL_RATIO;
  const x0 = cx + (radiusInner * Math.cos(-midAngle * DEG_TO_RAD_CONVERTER));
  const y0 = cy + (radiusInner * Math.sin(-midAngle * DEG_TO_RAD_CONVERTER));
  const x = cx + (radius * Math.cos(-midAngle * DEG_TO_RAD_CONVERTER));
  const y = cy + (radius * Math.sin(-midAngle * DEG_TO_RAD_CONVERTER));

  return { x0, y0, x, y };
};
